import React from 'react'
import { motion } from 'framer-motion'
import { Target, Shield, Users, CheckCircle } from 'lucide-react'
import SEO from '../components/SEO'

const PermanentPlacement = () => {
  const features = [
    'Comprehensive candidate screening',
    'Cultural fit assessment',
    '90-day placement guarantee',
    'Ongoing support and follow-up'
  ]

  return (
    <div>
      <SEO
        title="Permanent Placement & Recruitment Agency in Hyderabad | SV Manpower"
        description="Find top talent for long-term growth. SV Manpower offers recruitment & permanent staffing services in Hyderabad, connecting you with verified, qualified professionals."
        keywords="permanent placement Hyderabad, recruitment agency Hyderabad, permanent staffing services, hire employees Hyderabad, local headhunters Kukatpally"
        url="https://svmanpower.com/services/permanent-placement"
      />
      <section className="relative text-white py-20 lg:pt-32 bg-cover bg-center bg-no-repeat hero-bg-position" style={{ backgroundImage: 'url(/hero.webp)' }}>
        <div className="absolute inset-0 bg-gradient-to-r from-primary-600/80 to-primary-800/80"></div>
        <div className="container-max relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">Permanent Placement Services</h1>
            <p className="text-xl md:text-2xl text-primary-100">Find the perfect long-term fit for your organization</p>
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="container-max">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-secondary-900 mb-6">Quality Permanent Placements</h2>
              <p className="text-secondary-600 mb-6">Our permanent placement services focus on finding candidates who will thrive in your organization long-term. We take the time to understand your culture, values, and specific requirements.</p>
              <ul className="space-y-3">
                {features.map((feature, index) => (
                  <li key={index} className="flex items-center">
                    <CheckCircle className="w-5 h-5 text-green-500 mr-3" />
                    <span className="text-secondary-700">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <img src="https://images.unsplash.com/photo-1556761175-b413da4baf72?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Permanent Placement" className="rounded-lg shadow-xl" />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default PermanentPlacement
